import { apiRequest } from '@/lib/api-request';

/** The Dashboard's reads, all computed by the backend (GET /api/dashboard/*): the browser never queries a table for them. */
export interface DashboardKpis {
  active_projects: number;
  tasks: { active: number; overdue: number };
  purchase_orders: { active: number; overdue: number };
  budget: { total: number; utilized: number };
}

export type JobStage = 'Prospect' | 'Estimating' | 'In Progress' | 'Finishing' | 'Completed';

export interface DashboardJob {
  id: string;
  name: string;
  client_name: string | null;
  city: string | null;
  state: string | null;
  budget: number | null;
  start_date: string | null;
  end_date: string | null;
  /** the project's own status (the badge) */
  status: string;
  /** the stage derived from what exists for the project (the tab it appears under) */
  derived_status: JobStage;
  progress_pct: number;
}

export interface DashboardActivity {
  id: string;
  type: 'task' | 'daily_log' | 'purchase_order' | 'bill' | 'comment';
  title: string;
  description: string;
  actual_timestamp: string;
  user_name: string;
  project_name: string;
}

const projectQuery = (projectId?: string) => (projectId && projectId !== 'all' ? `project_id=${encodeURIComponent(projectId)}` : '');

export const fetchDashboardKpis = (projectId?: string) => {
  const query = projectQuery(projectId);
  return apiRequest<DashboardKpis>(`api/dashboard/kpis${query ? `?${query}` : ''}`);
};

export const fetchDashboardJobs = () => apiRequest<DashboardJob[]>('api/dashboard/jobs');

export const fetchDashboardActivity = (projectId: string | undefined, limit: number) => {
  const query = [projectQuery(projectId), `limit=${limit}`].filter(Boolean).join('&');
  return apiRequest<DashboardActivity[]>(`api/dashboard/activity?${query}`);
};
